export default {
  app: {
    notFound: {
      title: 'Puslapis nerastas.',
      subtitle: 'Atrodo, kad pasiklydote.',
      text: 'Nesijaudinkite, padėsime Jums grįžti į namus.',
    },
  },
};
